import { render } from "./GroupMemberCard.vue?vue&type=template&id=4ddb456e&scoped=true"
import script from "./GroupMemberCard.vue?vue&type=script&lang=js"
export * from "./GroupMemberCard.vue?vue&type=script&lang=js"

import "./GroupMemberCard.vue?vue&type=style&index=0&id=4ddb456e&scoped=true&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ddb456e"]])

export default __exports__